import axios from 'axios'
import {TenantFeatureList, UserModel} from '../models/UserModel'

const API_URL = process.env.REACT_APP_API_URL

export const LOGIN_URL = `${API_URL}/Authenticate/login`
export const LOGIN_2FA_URL = `${API_URL}/Authenticate/login-2FA`
export const ME_URL = `${API_URL}/Authenticate/me`
export const REFRESH_URL = `${API_URL}/Authenticate/refresh`
export const LOGOUT_URL = `${API_URL}/Authenticate/logout`
export const REGISTER_URL = `${API_URL}/Authenticate/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/Authenticate/forgot-password`

export const FEATURES_URL = `${API_URL}/Feature`
export const LOGIN_PAGE_SETTINGS_URL = `${API_URL}/Authenticate/login-page-settings`

// Server should return AuthModel
export function login(email: string, password: string, captcha: string | null) {
  return axios.post(
    LOGIN_URL,
    {
      email,
      password,
      captcha,
    },
    {
      withCredentials: true,
    }
  )
}

export function loginPageSettings() {
  return axios.get(LOGIN_PAGE_SETTINGS_URL)
}

export function login2Fa(email: string, code: string) {
  return axios.post(
    LOGIN_2FA_URL,
    {
      email,
      code,
    },
    {
      withCredentials: true,
    }
  )
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(
    REGISTER_URL,
    {
      email,
      first_name: firstname,
      last_name: lastname,
      password,
      password_confirmation,
    },
    {
      withCredentials: true,
    }
  )
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getCurrentUser() {
  return axios.get<UserModel>(ME_URL)
}

export function refreshSession(refreshToken?: string) {
  return axios.post(
    REFRESH_URL,
    {
      refreshToken,
    },
    {
      withCredentials: true,
    }
  )
}

export function logoutSession() {
  return axios.post(
    LOGOUT_URL,
    {},
    {
      withCredentials: true,
    }
  )
}

export function getFeaturesPerTenant() {
  return axios.get<TenantFeatureList>(`${FEATURES_URL}/FeaturesPerTenant`)
}
